import React from "react";
import PropTypes from "prop-types";
import { Field, FieldArray, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { patchQuestionnairePage } from "../../../redux/actions/sagaActions";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import TextField from "@material-ui/core/TextField";
import { withRouter } from "react-router-dom";

import AutoRenewIcon from "@material-ui/icons/Autorenew";
import DoneIcon from "@material-ui/icons/Done";
import "./questionnaire-page.css";
import { Button } from "reactstrap";

const renderTextField = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextField
    label={label}
    placeholder={label}
    error={touched && invalid}
    helperText={touched && error}
    {...input}
    {...custom}
  />
);

const renderField = ({
  input,
  label,
  type,
  meta: { touched, error },
  vc_profile
}) => (
  <div style={{ display: "none" }}>
    <label>{label}</label>
    <div>
      <input
        {...input}
        type={type}
        placeholder={label}
        value={input.value ? input.value : input.onChange(vc_profile)}
      />
      {touched && error && <span>{error}</span>}
    </div>
  </div>
);

const renderCheckbox = ({ input, label }) => (
  <div>
    <FormControlLabel
      control={
        <Checkbox
          checked={input.value ? true : false}
          onChange={input.onChange}
        />
      }
      label={label}
    />
  </div>
);

const radioButton = ({ input, ...rest }) => (
  <FormControl>
    <RadioGroup {...input} {...rest}>
      {rest.children}
    </RadioGroup>
  </FormControl>
);

const radioButtonTrueFalse = ({ input, ...rest }) => (
  <div>
    <FormControl>
      <RadioGroup {...input} {...rest}>
        <FormControlLabel value={"1"} control={<Radio />} label={"Si"} />
        <FormControlLabel value={"0"} control={<Radio />} label={"No"} />
      </RadioGroup>
    </FormControl>
  </div>
);

const renderQuestions = ({
  fields,
  meta: { error, submitFailed },
  vc_profile
}) => {
  return (
    <div>
      {fields.map((field, index) => {
        let currentField = fields.get(index);
        let profileIndex = currentField.vc_profiles.findIndex(
          profile => profile.vc_profile === vc_profile
        );
        profileIndex =
          profileIndex > -1 ? profileIndex : currentField.vc_profiles.length;
        const getHeader = text => (
          <p className={"questionnaire-page-question-header"}>{text}</p>
        );
        switch (currentField.type) {
          case "text":
            return (
              <div
                className={"questionnaire-page-question"}
                key={`${currentField.id}_${index}_fragment`}
              >
                {getHeader(currentField.name)}
                <Field
                  key={`${currentField.id}_${index}`}
                  name={`${field}.vc_profiles[${profileIndex}].answers`}
                  component={renderTextField}
                />
                <Field
                  key={`${currentField.name}${index}`}
                  name={`${field}.vc_profiles[${profileIndex}].vc_profile`}
                  value={vc_profile.toString()}
                  component={renderField}
                  vc_profile={vc_profile}
                />
              </div>
            );
          case "checkbox":
            return (
              <div
                className={"questionnaire-page-question"}
                key={`${currentField.id}_${index}_fragment`}
              >
                {getHeader(currentField.name)}
                {currentField.answers.map((answer, index) => (
                  <Field
                    key={`${currentField.id}_${index}`}
                    name={`${field}.vc_profiles[${profileIndex}].answers[${index}]`}
                    label={answer}
                    component={renderCheckbox}
                  />
                ))}
                <Field
                  key={`${currentField.name}${index}`}
                  name={`${field}.vc_profiles[${profileIndex}].vc_profile`}
                  value={vc_profile}
                  component={renderField}
                  vc_profile={vc_profile}
                />
              </div>
            );
          case "radio":
            return (
              <div
                className={"questionnaire-page-question"}
                key={`${currentField.id}_${index}_fragment`}
              >
                {getHeader(currentField.name)}
                <Field
                  name={`${field}.vc_profiles[${profileIndex}].answers`}
                  component={radioButton}
                >
                  {currentField.answers.map((answer, index) => (
                    <FormControlLabel
                      key={`radio_${answer}_${index}`}
                      value={answer}
                      control={<Radio />}
                      label={answer}
                    />
                  ))}
                </Field>
                <Field
                  key={`${currentField.name}${index}`}
                  name={`${field}.vc_profiles[${profileIndex}].vc_profile`}
                  value={vc_profile}
                  component={renderField}
                  vc_profile={vc_profile}
                />
              </div>
            );
          case "bool":
            return (
              <div
                className={"questionnaire-page-question"}
                key={`${currentField.id}_${index}_fragment`}
              >
                {getHeader(currentField.name)}
                <Field
                  name={`${field}.vc_profiles[${profileIndex}].answers`}
                  component={radioButtonTrueFalse}
                />
                <Field
                  key={`${currentField.name}${index}`}
                  name={`${field}.vc_profiles[${profileIndex}].vc_profile`}
                  value={vc_profile}
                  component={renderField}
                  vc_profile={vc_profile}
                />
              </div>
            );
        }
      })}
    </div>
  );
};

const QuestionnairePage = props => {
  const {
    page,
    vc_profile,
    patchQuestionnairePage,
    handleSubmit,
    network,
    match: {
      params: { id }
    }
  } = props;
  const submit = values => {
    patchQuestionnairePage({ ...values, invitation: id });
  };
  return (
    <form onSubmit={handleSubmit(submit)}>
      <FieldArray
        name={"questions"}
        component={renderQuestions}
        vc_profile={vc_profile}
      />
      <Button color="danger" type={"submit"} style={{ margin: "1rem 0" }}>
        Guardar{" "}
        {network[page.id] && network[page.id].loading && (
          <AutoRenewIcon className={"questionnaire-page-loader"} />
        )}
        {network[page.id] && network[page.id].saved && <DoneIcon />}
      </Button>
    </form>
  );
};

QuestionnairePage.propTypes = {
  page: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  vc_profile: state.account.data.id,
  network: state.network.questionnaire_pages
});

export default reduxForm({
  form: "QuestionnairePage",
  enableReinitialize: true,
  destroyOnUnmount: false
})(
  connect(
    mapStateToProps,
    { patchQuestionnairePage }
  )(withRouter(QuestionnairePage))
);



// WEBPACK FOOTER //
// ./src/modules/test/components/QuestionnairePage.js